// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/operacional/services/liberacaoDescontoService.ts
//  Workflow de liberação de desconto.
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';

const BASE = '/api/liberacoes-desconto';

export const STATUS_LIBERACAO = {
  PENDENTE: 0,
  APROVADA: 1,
  REJEITADA: 2,
} as const;

export interface LiberacaoDesconto {
  id: number;
  solicitanteId: number;
  tipoDocumento?: string;
  documentoId: number;
  produtoId: number;
  valorOriginal: number;
  percentualSolicitado: number;
  valorDesconto: number;
  motivo?: string;
  status: number;
  statusDescricao: string;
  aprovadorId: number;
  justificativaDecisao?: string;
  dtSolicitacao: string;
  dtDecisao?: string;
}

export interface SolicitarLiberacaoDescontoRequest {
  percentualSolicitado: number;
  valorOriginal?: number;
  valorDesconto?: number;
  tipoDocumento?: string;
  documentoId?: number;
  produtoId?: number;
  motivo?: string;
}

export const liberacaoDescontoService = {
  async getAll(status?: number, dtInicio?: string, dtFim?: string): Promise<LiberacaoDesconto[]> {
    const { data } = await apiClient.get<LiberacaoDesconto[]>(BASE, {
      params: { status, dtInicio: dtInicio || undefined, dtFim: dtFim || undefined },
    });
    return data;
  },

  async solicitar(request: SolicitarLiberacaoDescontoRequest): Promise<LiberacaoDesconto> {
    const { data } = await apiClient.post<LiberacaoDesconto>(BASE, request);
    return data;
  },

  async aprovar(id: number, justificativa?: string): Promise<LiberacaoDesconto> {
    const { data } = await apiClient.post<LiberacaoDesconto>(`${BASE}/${id}/aprovar`, { justificativa });
    return data;
  },

  async rejeitar(id: number, justificativa: string): Promise<LiberacaoDesconto> {
    const { data } = await apiClient.post<LiberacaoDesconto>(`${BASE}/${id}/rejeitar`, { justificativa });
    return data;
  },
};
